import styled from 'styled-components'

export const Container = styled.div`
  width: 90vw;
  height: 90vh;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const CloseContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button {
    background: inherit;
    border: none;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`

export const InvoiceCloudFrame = styled.iframe`
  width: 100%;
  height: 100%;
`

export const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: blue;

  img {
    width: 64px;
    height: 64px;
  }
`